/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ARouteImport } from './routes/_a'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AIndexRouteImport } from './routes/_a.index'
import { Route as ASplatRouteImport } from './routes/_a.$'
import { Route as AAgaveConnectorStatusRouteImport } from './routes/_a.agaveConnectorStatus'
import { Route as AAgaveEndpointsRouteImport } from './routes/_a.agaveEndpoints'
import { Route as ABillingHistoryRouteImport } from './routes/_a.billingHistory'
import { Route as ACachingRouteImport } from './routes/_a.caching'
import { Route as AContractMismatchReportGroupsRouteImport } from './routes/_a.contractMismatchReportGroups'
import { Route as ACustomerDashboardsRouteImport } from './routes/_a.customerDashboards'
import { Route as ACustomerLocationsMapRouteImport } from './routes/_a.customerLocationsMap'
import { Route as ADemoToolsRouteImport } from './routes/_a.demoTools'
import { Route as AFeatureFlagsRouteImport } from './routes/_a.featureFlags'
import { Route as AFormTurnaroundRouteImport } from './routes/_a.formTurnaround'
import { Route as AGcDedupeRouteImport } from './routes/_a.gcDedupe'
import { Route as AIntegrationRequestsRouteImport } from './routes/_a.integrationRequests'
import { Route as AJobsRouteImport } from './routes/_a.jobs'
import { Route as AProcessingContractsRouteImport } from './routes/_a.processingContracts'
import { Route as AReportingRouteImport } from './routes/_a.reporting'
import { Route as ASitelordRouteImport } from './routes/_a.sitelord'
import { Route as AWriteSyncOperationsRouteImport } from './routes/_a.writeSyncOperations'
import { Route as ACampaignsIndexRouteImport } from './routes/_a.campaigns.index'
import { Route as ACampaignsCampaignIdRouteImport } from './routes/_a.campaigns.$campaignId'
import { Route as ACampaignsCreateRouteImport } from './routes/_a.campaigns.create'
import { Route as ACompaniesCreateRouteImport } from './routes/_a.companies.create'
import { Route as AContractsContractIdRouteImport } from './routes/_a.contracts.$contractId'
import { Route as ALegalDocumentsRequirementIdRouteImport } from './routes/_a.legalDocuments.$requirementId'
import { Route as ALienRightsRequirementsIndexRouteImport } from './routes/_a.lienRightsRequirements.index'
import { Route as ALienRightsRequirementsStateRouteImport } from './routes/_a.lienRightsRequirements.$state'
import { Route as APayAppsPayAppIdRouteImport } from './routes/_a.payApps.$payAppId'
import { Route as APeyoteDebuggerRouteImport } from './routes/_a.peyote.debugger'
import { Route as AProjectsProjectIdRouteImport } from './routes/_a.projects.$projectId'
import { Route as ATemplateVariablesIndexRouteImport } from './routes/_a.templateVariables.index'
import { Route as ATemplateVariablesLookupRouteImport } from './routes/_a.templateVariables.lookup'
import { Route as ATemplatesIndexRouteImport } from './routes/_a.templates.index'
import { Route as ATemplatesCreateRouteImport } from './routes/_a.templates.create'
import { Route as ATemplatesMatchRouteImport } from './routes/_a.templates.match'
import { Route as AUsersUserIdRouteImport } from './routes/_a.users.$userId'
import { Route as ACompaniesCompanyIdIndexRouteImport } from './routes/_a.companies.$companyId.index'
import { Route as ACompaniesCompanyIdFormSetsRouteImport } from './routes/_a.companies.$companyId.formSets'
import { Route as ATemplatesTemplateIdIndexRouteImport } from './routes/_a.templates.$templateId.index'
import { Route as ATemplatesTemplateIdEditRouteImport } from './routes/_a.templates.$templateId.edit'
import { Route as ATemplatesTemplateIdVersionsCreateRouteImport } from './routes/_a.templates.$templateId.versions.create'
import { Route as ATemplatesTemplateIdVersionsVersionIdIndexRouteImport } from './routes/_a.templates.$templateId.versions.$versionId.index'
import { Route as ATemplatesTemplateIdVersionsVersionIdEditRouteImport } from './routes/_a.templates.$templateId.versions.$versionId.edit'

const ARoute = ARouteImport.update({
  id: '/_a',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AIndexRoute = AIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ARoute,
} as any)
const ASplatRoute = ASplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => ARoute,
} as any)
const AAgaveConnectorStatusRoute = AAgaveConnectorStatusRouteImport.update({
  id: '/agaveConnectorStatus',
  path: '/agaveConnectorStatus',
  getParentRoute: () => ARoute,
} as any)
const AAgaveEndpointsRoute = AAgaveEndpointsRouteImport.update({
  id: '/agaveEndpoints',
  path: '/agaveEndpoints',
  getParentRoute: () => ARoute,
} as any)
const ABillingHistoryRoute = ABillingHistoryRouteImport.update({
  id: '/billingHistory',
  path: '/billingHistory',
  getParentRoute: () => ARoute,
} as any)
const ACachingRoute = ACachingRouteImport.update({
  id: '/caching',
  path: '/caching',
  getParentRoute: () => ARoute,
} as any)
const AContractMismatchReportGroupsRoute =
  AContractMismatchReportGroupsRouteImport.update({
    id: '/contractMismatchReportGroups',
    path: '/contractMismatchReportGroups',
    getParentRoute: () => ARoute,
  } as any)
const ACustomerDashboardsRoute = ACustomerDashboardsRouteImport.update({
  id: '/customerDashboards',
  path: '/customerDashboards',
  getParentRoute: () => ARoute,
} as any)
const ACustomerLocationsMapRoute = ACustomerLocationsMapRouteImport.update({
  id: '/customerLocationsMap',
  path: '/customerLocationsMap',
  getParentRoute: () => ARoute,
} as any)
const ADemoToolsRoute = ADemoToolsRouteImport.update({
  id: '/demoTools',
  path: '/demoTools',
  getParentRoute: () => ARoute,
} as any)
const AFeatureFlagsRoute = AFeatureFlagsRouteImport.update({
  id: '/featureFlags',
  path: '/featureFlags',
  getParentRoute: () => ARoute,
} as any)
const AFormTurnaroundRoute = AFormTurnaroundRouteImport.update({
  id: '/formTurnaround',
  path: '/formTurnaround',
  getParentRoute: () => ARoute,
} as any)
const AGcDedupeRoute = AGcDedupeRouteImport.update({
  id: '/gcDedupe',
  path: '/gcDedupe',
  getParentRoute: () => ARoute,
} as any)
const AIntegrationRequestsRoute = AIntegrationRequestsRouteImport.update({
  id: '/integrationRequests',
  path: '/integrationRequests',
  getParentRoute: () => ARoute,
} as any)
const AJobsRoute = AJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => ARoute,
} as any)
const AProcessingContractsRoute = AProcessingContractsRouteImport.update({
  id: '/processingContracts',
  path: '/processingContracts',
  getParentRoute: () => ARoute,
} as any)
const AReportingRoute = AReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => ARoute,
} as any)
const ASitelordRoute = ASitelordRouteImport.update({
  id: '/sitelord',
  path: '/sitelord',
  getParentRoute: () => ARoute,
} as any)
const AWriteSyncOperationsRoute = AWriteSyncOperationsRouteImport.update({
  id: '/writeSyncOperations',
  path: '/writeSyncOperations',
  getParentRoute: () => ARoute,
} as any)
const ACampaignsIndexRoute = ACampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => ARoute,
} as any)
const ACampaignsCampaignIdRoute = ACampaignsCampaignIdRouteImport.update({
  id: '/campaigns/$campaignId',
  path: '/campaigns/$campaignId',
  getParentRoute: () => ARoute,
} as any)
const ACampaignsCreateRoute = ACampaignsCreateRouteImport.update({
  id: '/campaigns/create',
  path: '/campaigns/create',
  getParentRoute: () => ARoute,
} as any)
const ACompaniesCreateRoute = ACompaniesCreateRouteImport.update({
  id: '/companies/create',
  path: '/companies/create',
  getParentRoute: () => ARoute,
} as any)
const AContractsContractIdRoute = AContractsContractIdRouteImport.update({
  id: '/contracts/$contractId',
  path: '/contracts/$contractId',
  getParentRoute: () => ARoute,
} as any)
const ALegalDocumentsRequirementIdRoute =
  ALegalDocumentsRequirementIdRouteImport.update({
    id: '/legalDocuments/$requirementId',
    path: '/legalDocuments/$requirementId',
    getParentRoute: () => ARoute,
  } as any)
const ALienRightsRequirementsIndexRoute =
  ALienRightsRequirementsIndexRouteImport.update({
    id: '/lienRightsRequirements/',
    path: '/lienRightsRequirements/',
    getParentRoute: () => ARoute,
  } as any)
const ALienRightsRequirementsStateRoute =
  ALienRightsRequirementsStateRouteImport.update({
    id: '/lienRightsRequirements/$state',
    path: '/lienRightsRequirements/$state',
    getParentRoute: () => ARoute,
  } as any)
const APayAppsPayAppIdRoute = APayAppsPayAppIdRouteImport.update({
  id: '/payApps/$payAppId',
  path: '/payApps/$payAppId',
  getParentRoute: () => ARoute,
} as any)
const APeyoteDebuggerRoute = APeyoteDebuggerRouteImport.update({
  id: '/peyote/debugger',
  path: '/peyote/debugger',
  getParentRoute: () => ARoute,
} as any)
const AProjectsProjectIdRoute = AProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => ARoute,
} as any)
const ATemplateVariablesIndexRoute = ATemplateVariablesIndexRouteImport.update({
  id: '/templateVariables/',
  path: '/templateVariables/',
  getParentRoute: () => ARoute,
} as any)
const ATemplateVariablesLookupRoute =
  ATemplateVariablesLookupRouteImport.update({
    id: '/templateVariables/lookup',
    path: '/templateVariables/lookup',
    getParentRoute: () => ARoute,
  } as any)
const ATemplatesIndexRoute = ATemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => ARoute,
} as any)
const ATemplatesCreateRoute = ATemplatesCreateRouteImport.update({
  id: '/templates/create',
  path: '/templates/create',
  getParentRoute: () => ARoute,
} as any)
const ATemplatesMatchRoute = ATemplatesMatchRouteImport.update({
  id: '/templates/match',
  path: '/templates/match',
  getParentRoute: () => ARoute,
} as any)
const AUsersUserIdRoute = AUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => ARoute,
} as any)
const ACompaniesCompanyIdIndexRoute =
  ACompaniesCompanyIdIndexRouteImport.update({
    id: '/companies/$companyId/',
    path: '/companies/$companyId/',
    getParentRoute: () => ARoute,
  } as any)
const ACompaniesCompanyIdFormSetsRoute =
  ACompaniesCompanyIdFormSetsRouteImport.update({
    id: '/companies/$companyId/formSets',
    path: '/companies/$companyId/formSets',
    getParentRoute: () => ARoute,
  } as any)
const ATemplatesTemplateIdIndexRoute =
  ATemplatesTemplateIdIndexRouteImport.update({
    id: '/templates/$templateId/',
    path: '/templates/$templateId/',
    getParentRoute: () => ARoute,
  } as any)
const ATemplatesTemplateIdEditRoute =
  ATemplatesTemplateIdEditRouteImport.update({
    id: '/templates/$templateId/edit',
    path: '/templates/$templateId/edit',
    getParentRoute: () => ARoute,
  } as any)
const ATemplatesTemplateIdVersionsCreateRoute =
  ATemplatesTemplateIdVersionsCreateRouteImport.update({
    id: '/templates/$templateId/versions/create',
    path: '/templates/$templateId/versions/create',
    getParentRoute: () => ARoute,
  } as any)
const ATemplatesTemplateIdVersionsVersionIdIndexRoute =
  ATemplatesTemplateIdVersionsVersionIdIndexRouteImport.update({
    id: '/templates/$templateId/versions/$versionId/',
    path: '/templates/$templateId/versions/$versionId/',
    getParentRoute: () => ARoute,
  } as any)
const ATemplatesTemplateIdVersionsVersionIdEditRoute =
  ATemplatesTemplateIdVersionsVersionIdEditRouteImport.update({
    id: '/templates/$templateId/versions/$versionId/edit',
    path: '/templates/$templateId/versions/$versionId/edit',
    getParentRoute: () => ARoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AIndexRoute
  '/signin': typeof SigninRoute
  '/$': typeof ASplatRoute
  '/agaveConnectorStatus': typeof AAgaveConnectorStatusRoute
  '/agaveEndpoints': typeof AAgaveEndpointsRoute
  '/billingHistory': typeof ABillingHistoryRoute
  '/caching': typeof ACachingRoute
  '/contractMismatchReportGroups': typeof AContractMismatchReportGroupsRoute
  '/customerDashboards': typeof ACustomerDashboardsRoute
  '/customerLocationsMap': typeof ACustomerLocationsMapRoute
  '/demoTools': typeof ADemoToolsRoute
  '/featureFlags': typeof AFeatureFlagsRoute
  '/formTurnaround': typeof AFormTurnaroundRoute
  '/gcDedupe': typeof AGcDedupeRoute
  '/integrationRequests': typeof AIntegrationRequestsRoute
  '/jobs': typeof AJobsRoute
  '/processingContracts': typeof AProcessingContractsRoute
  '/reporting': typeof AReportingRoute
  '/sitelord': typeof ASitelordRoute
  '/writeSyncOperations': typeof AWriteSyncOperationsRoute
  '/campaigns/$campaignId': typeof ACampaignsCampaignIdRoute
  '/campaigns/create': typeof ACampaignsCreateRoute
  '/companies/create': typeof ACompaniesCreateRoute
  '/contracts/$contractId': typeof AContractsContractIdRoute
  '/legalDocuments/$requirementId': typeof ALegalDocumentsRequirementIdRoute
  '/lienRightsRequirements/$state': typeof ALienRightsRequirementsStateRoute
  '/payApps/$payAppId': typeof APayAppsPayAppIdRoute
  '/peyote/debugger': typeof APeyoteDebuggerRoute
  '/projects/$projectId': typeof AProjectsProjectIdRoute
  '/templateVariables/lookup': typeof ATemplateVariablesLookupRoute
  '/templates/create': typeof ATemplatesCreateRoute
  '/templates/match': typeof ATemplatesMatchRoute
  '/users/$userId': typeof AUsersUserIdRoute
  '/campaigns/': typeof ACampaignsIndexRoute
  '/lienRightsRequirements/': typeof ALienRightsRequirementsIndexRoute
  '/templateVariables/': typeof ATemplateVariablesIndexRoute
  '/templates/': typeof ATemplatesIndexRoute
  '/companies/$companyId/formSets': typeof ACompaniesCompanyIdFormSetsRoute
  '/templates/$templateId/edit': typeof ATemplatesTemplateIdEditRoute
  '/companies/$companyId/': typeof ACompaniesCompanyIdIndexRoute
  '/templates/$templateId/': typeof ATemplatesTemplateIdIndexRoute
  '/templates/$templateId/versions/create': typeof ATemplatesTemplateIdVersionsCreateRoute
  '/templates/$templateId/versions/$versionId/edit': typeof ATemplatesTemplateIdVersionsVersionIdEditRoute
  '/templates/$templateId/versions/$versionId/': typeof ATemplatesTemplateIdVersionsVersionIdIndexRoute
}
export interface FileRoutesByTo {
  '/signin': typeof SigninRoute
  '/$': typeof ASplatRoute
  '/agaveConnectorStatus': typeof AAgaveConnectorStatusRoute
  '/agaveEndpoints': typeof AAgaveEndpointsRoute
  '/billingHistory': typeof ABillingHistoryRoute
  '/caching': typeof ACachingRoute
  '/contractMismatchReportGroups': typeof AContractMismatchReportGroupsRoute
  '/customerDashboards': typeof ACustomerDashboardsRoute
  '/customerLocationsMap': typeof ACustomerLocationsMapRoute
  '/demoTools': typeof ADemoToolsRoute
  '/featureFlags': typeof AFeatureFlagsRoute
  '/formTurnaround': typeof AFormTurnaroundRoute
  '/gcDedupe': typeof AGcDedupeRoute
  '/integrationRequests': typeof AIntegrationRequestsRoute
  '/jobs': typeof AJobsRoute
  '/processingContracts': typeof AProcessingContractsRoute
  '/reporting': typeof AReportingRoute
  '/sitelord': typeof ASitelordRoute
  '/writeSyncOperations': typeof AWriteSyncOperationsRoute
  '/': typeof AIndexRoute
  '/campaigns/$campaignId': typeof ACampaignsCampaignIdRoute
  '/campaigns/create': typeof ACampaignsCreateRoute
  '/companies/create': typeof ACompaniesCreateRoute
  '/contracts/$contractId': typeof AContractsContractIdRoute
  '/legalDocuments/$requirementId': typeof ALegalDocumentsRequirementIdRoute
  '/lienRightsRequirements/$state': typeof ALienRightsRequirementsStateRoute
  '/payApps/$payAppId': typeof APayAppsPayAppIdRoute
  '/peyote/debugger': typeof APeyoteDebuggerRoute
  '/projects/$projectId': typeof AProjectsProjectIdRoute
  '/templateVariables/lookup': typeof ATemplateVariablesLookupRoute
  '/templates/create': typeof ATemplatesCreateRoute
  '/templates/match': typeof ATemplatesMatchRoute
  '/users/$userId': typeof AUsersUserIdRoute
  '/campaigns': typeof ACampaignsIndexRoute
  '/lienRightsRequirements': typeof ALienRightsRequirementsIndexRoute
  '/templateVariables': typeof ATemplateVariablesIndexRoute
  '/templates': typeof ATemplatesIndexRoute
  '/companies/$companyId/formSets': typeof ACompaniesCompanyIdFormSetsRoute
  '/templates/$templateId/edit': typeof ATemplatesTemplateIdEditRoute
  '/companies/$companyId': typeof ACompaniesCompanyIdIndexRoute
  '/templates/$templateId': typeof ATemplatesTemplateIdIndexRoute
  '/templates/$templateId/versions/create': typeof ATemplatesTemplateIdVersionsCreateRoute
  '/templates/$templateId/versions/$versionId/edit': typeof ATemplatesTemplateIdVersionsVersionIdEditRoute
  '/templates/$templateId/versions/$versionId': typeof ATemplatesTemplateIdVersionsVersionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_a': typeof ARouteWithChildren
  '/signin': typeof SigninRoute
  '/_a/$': typeof ASplatRoute
  '/_a/agaveConnectorStatus': typeof AAgaveConnectorStatusRoute
  '/_a/agaveEndpoints': typeof AAgaveEndpointsRoute
  '/_a/billingHistory': typeof ABillingHistoryRoute
  '/_a/caching': typeof ACachingRoute
  '/_a/contractMismatchReportGroups': typeof AContractMismatchReportGroupsRoute
  '/_a/customerDashboards': typeof ACustomerDashboardsRoute
  '/_a/customerLocationsMap': typeof ACustomerLocationsMapRoute
  '/_a/demoTools': typeof ADemoToolsRoute
  '/_a/featureFlags': typeof AFeatureFlagsRoute
  '/_a/formTurnaround': typeof AFormTurnaroundRoute
  '/_a/gcDedupe': typeof AGcDedupeRoute
  '/_a/integrationRequests': typeof AIntegrationRequestsRoute
  '/_a/jobs': typeof AJobsRoute
  '/_a/processingContracts': typeof AProcessingContractsRoute
  '/_a/reporting': typeof AReportingRoute
  '/_a/sitelord': typeof ASitelordRoute
  '/_a/writeSyncOperations': typeof AWriteSyncOperationsRoute
  '/_a/': typeof AIndexRoute
  '/_a/campaigns/$campaignId': typeof ACampaignsCampaignIdRoute
  '/_a/campaigns/create': typeof ACampaignsCreateRoute
  '/_a/companies/create': typeof ACompaniesCreateRoute
  '/_a/contracts/$contractId': typeof AContractsContractIdRoute
  '/_a/legalDocuments/$requirementId': typeof ALegalDocumentsRequirementIdRoute
  '/_a/lienRightsRequirements/$state': typeof ALienRightsRequirementsStateRoute
  '/_a/payApps/$payAppId': typeof APayAppsPayAppIdRoute
  '/_a/peyote/debugger': typeof APeyoteDebuggerRoute
  '/_a/projects/$projectId': typeof AProjectsProjectIdRoute
  '/_a/templateVariables/lookup': typeof ATemplateVariablesLookupRoute
  '/_a/templates/create': typeof ATemplatesCreateRoute
  '/_a/templates/match': typeof ATemplatesMatchRoute
  '/_a/users/$userId': typeof AUsersUserIdRoute
  '/_a/campaigns/': typeof ACampaignsIndexRoute
  '/_a/lienRightsRequirements/': typeof ALienRightsRequirementsIndexRoute
  '/_a/templateVariables/': typeof ATemplateVariablesIndexRoute
  '/_a/templates/': typeof ATemplatesIndexRoute
  '/_a/companies/$companyId/formSets': typeof ACompaniesCompanyIdFormSetsRoute
  '/_a/templates/$templateId/edit': typeof ATemplatesTemplateIdEditRoute
  '/_a/companies/$companyId/': typeof ACompaniesCompanyIdIndexRoute
  '/_a/templates/$templateId/': typeof ATemplatesTemplateIdIndexRoute
  '/_a/templates/$templateId/versions/create': typeof ATemplatesTemplateIdVersionsCreateRoute
  '/_a/templates/$templateId/versions/$versionId/edit': typeof ATemplatesTemplateIdVersionsVersionIdEditRoute
  '/_a/templates/$templateId/versions/$versionId/': typeof ATemplatesTemplateIdVersionsVersionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/$'
    | '/agaveConnectorStatus'
    | '/agaveEndpoints'
    | '/billingHistory'
    | '/caching'
    | '/contractMismatchReportGroups'
    | '/customerDashboards'
    | '/customerLocationsMap'
    | '/demoTools'
    | '/featureFlags'
    | '/formTurnaround'
    | '/gcDedupe'
    | '/integrationRequests'
    | '/jobs'
    | '/processingContracts'
    | '/reporting'
    | '/sitelord'
    | '/writeSyncOperations'
    | '/campaigns/$campaignId'
    | '/campaigns/create'
    | '/companies/create'
    | '/contracts/$contractId'
    | '/legalDocuments/$requirementId'
    | '/lienRightsRequirements/$state'
    | '/payApps/$payAppId'
    | '/peyote/debugger'
    | '/projects/$projectId'
    | '/templateVariables/lookup'
    | '/templates/create'
    | '/templates/match'
    | '/users/$userId'
    | '/campaigns/'
    | '/lienRightsRequirements/'
    | '/templateVariables/'
    | '/templates/'
    | '/companies/$companyId/formSets'
    | '/templates/$templateId/edit'
    | '/companies/$companyId/'
    | '/templates/$templateId/'
    | '/templates/$templateId/versions/create'
    | '/templates/$templateId/versions/$versionId/edit'
    | '/templates/$templateId/versions/$versionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signin'
    | '/$'
    | '/agaveConnectorStatus'
    | '/agaveEndpoints'
    | '/billingHistory'
    | '/caching'
    | '/contractMismatchReportGroups'
    | '/customerDashboards'
    | '/customerLocationsMap'
    | '/demoTools'
    | '/featureFlags'
    | '/formTurnaround'
    | '/gcDedupe'
    | '/integrationRequests'
    | '/jobs'
    | '/processingContracts'
    | '/reporting'
    | '/sitelord'
    | '/writeSyncOperations'
    | '/'
    | '/campaigns/$campaignId'
    | '/campaigns/create'
    | '/companies/create'
    | '/contracts/$contractId'
    | '/legalDocuments/$requirementId'
    | '/lienRightsRequirements/$state'
    | '/payApps/$payAppId'
    | '/peyote/debugger'
    | '/projects/$projectId'
    | '/templateVariables/lookup'
    | '/templates/create'
    | '/templates/match'
    | '/users/$userId'
    | '/campaigns'
    | '/lienRightsRequirements'
    | '/templateVariables'
    | '/templates'
    | '/companies/$companyId/formSets'
    | '/templates/$templateId/edit'
    | '/companies/$companyId'
    | '/templates/$templateId'
    | '/templates/$templateId/versions/create'
    | '/templates/$templateId/versions/$versionId/edit'
    | '/templates/$templateId/versions/$versionId'
  id:
    | '__root__'
    | '/_a'
    | '/signin'
    | '/_a/$'
    | '/_a/agaveConnectorStatus'
    | '/_a/agaveEndpoints'
    | '/_a/billingHistory'
    | '/_a/caching'
    | '/_a/contractMismatchReportGroups'
    | '/_a/customerDashboards'
    | '/_a/customerLocationsMap'
    | '/_a/demoTools'
    | '/_a/featureFlags'
    | '/_a/formTurnaround'
    | '/_a/gcDedupe'
    | '/_a/integrationRequests'
    | '/_a/jobs'
    | '/_a/processingContracts'
    | '/_a/reporting'
    | '/_a/sitelord'
    | '/_a/writeSyncOperations'
    | '/_a/'
    | '/_a/campaigns/$campaignId'
    | '/_a/campaigns/create'
    | '/_a/companies/create'
    | '/_a/contracts/$contractId'
    | '/_a/legalDocuments/$requirementId'
    | '/_a/lienRightsRequirements/$state'
    | '/_a/payApps/$payAppId'
    | '/_a/peyote/debugger'
    | '/_a/projects/$projectId'
    | '/_a/templateVariables/lookup'
    | '/_a/templates/create'
    | '/_a/templates/match'
    | '/_a/users/$userId'
    | '/_a/campaigns/'
    | '/_a/lienRightsRequirements/'
    | '/_a/templateVariables/'
    | '/_a/templates/'
    | '/_a/companies/$companyId/formSets'
    | '/_a/templates/$templateId/edit'
    | '/_a/companies/$companyId/'
    | '/_a/templates/$templateId/'
    | '/_a/templates/$templateId/versions/create'
    | '/_a/templates/$templateId/versions/$versionId/edit'
    | '/_a/templates/$templateId/versions/$versionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ARoute: typeof ARouteWithChildren
  SigninRoute: typeof SigninRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_a': {
      id: '/_a'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ARouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_a/': {
      id: '/_a/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AIndexRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/$': {
      id: '/_a/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof ASplatRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/agaveConnectorStatus': {
      id: '/_a/agaveConnectorStatus'
      path: '/agaveConnectorStatus'
      fullPath: '/agaveConnectorStatus'
      preLoaderRoute: typeof AAgaveConnectorStatusRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/agaveEndpoints': {
      id: '/_a/agaveEndpoints'
      path: '/agaveEndpoints'
      fullPath: '/agaveEndpoints'
      preLoaderRoute: typeof AAgaveEndpointsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/billingHistory': {
      id: '/_a/billingHistory'
      path: '/billingHistory'
      fullPath: '/billingHistory'
      preLoaderRoute: typeof ABillingHistoryRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/caching': {
      id: '/_a/caching'
      path: '/caching'
      fullPath: '/caching'
      preLoaderRoute: typeof ACachingRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/contractMismatchReportGroups': {
      id: '/_a/contractMismatchReportGroups'
      path: '/contractMismatchReportGroups'
      fullPath: '/contractMismatchReportGroups'
      preLoaderRoute: typeof AContractMismatchReportGroupsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/customerDashboards': {
      id: '/_a/customerDashboards'
      path: '/customerDashboards'
      fullPath: '/customerDashboards'
      preLoaderRoute: typeof ACustomerDashboardsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/customerLocationsMap': {
      id: '/_a/customerLocationsMap'
      path: '/customerLocationsMap'
      fullPath: '/customerLocationsMap'
      preLoaderRoute: typeof ACustomerLocationsMapRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/demoTools': {
      id: '/_a/demoTools'
      path: '/demoTools'
      fullPath: '/demoTools'
      preLoaderRoute: typeof ADemoToolsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/featureFlags': {
      id: '/_a/featureFlags'
      path: '/featureFlags'
      fullPath: '/featureFlags'
      preLoaderRoute: typeof AFeatureFlagsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/formTurnaround': {
      id: '/_a/formTurnaround'
      path: '/formTurnaround'
      fullPath: '/formTurnaround'
      preLoaderRoute: typeof AFormTurnaroundRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/gcDedupe': {
      id: '/_a/gcDedupe'
      path: '/gcDedupe'
      fullPath: '/gcDedupe'
      preLoaderRoute: typeof AGcDedupeRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/integrationRequests': {
      id: '/_a/integrationRequests'
      path: '/integrationRequests'
      fullPath: '/integrationRequests'
      preLoaderRoute: typeof AIntegrationRequestsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/jobs': {
      id: '/_a/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AJobsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/processingContracts': {
      id: '/_a/processingContracts'
      path: '/processingContracts'
      fullPath: '/processingContracts'
      preLoaderRoute: typeof AProcessingContractsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/reporting': {
      id: '/_a/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof AReportingRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/sitelord': {
      id: '/_a/sitelord'
      path: '/sitelord'
      fullPath: '/sitelord'
      preLoaderRoute: typeof ASitelordRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/writeSyncOperations': {
      id: '/_a/writeSyncOperations'
      path: '/writeSyncOperations'
      fullPath: '/writeSyncOperations'
      preLoaderRoute: typeof AWriteSyncOperationsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/campaigns/': {
      id: '/_a/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof ACampaignsIndexRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/campaigns/$campaignId': {
      id: '/_a/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof ACampaignsCampaignIdRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/campaigns/create': {
      id: '/_a/campaigns/create'
      path: '/campaigns/create'
      fullPath: '/campaigns/create'
      preLoaderRoute: typeof ACampaignsCreateRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/companies/create': {
      id: '/_a/companies/create'
      path: '/companies/create'
      fullPath: '/companies/create'
      preLoaderRoute: typeof ACompaniesCreateRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/contracts/$contractId': {
      id: '/_a/contracts/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/contracts/$contractId'
      preLoaderRoute: typeof AContractsContractIdRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/legalDocuments/$requirementId': {
      id: '/_a/legalDocuments/$requirementId'
      path: '/legalDocuments/$requirementId'
      fullPath: '/legalDocuments/$requirementId'
      preLoaderRoute: typeof ALegalDocumentsRequirementIdRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/lienRightsRequirements/': {
      id: '/_a/lienRightsRequirements/'
      path: '/lienRightsRequirements'
      fullPath: '/lienRightsRequirements/'
      preLoaderRoute: typeof ALienRightsRequirementsIndexRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/lienRightsRequirements/$state': {
      id: '/_a/lienRightsRequirements/$state'
      path: '/lienRightsRequirements/$state'
      fullPath: '/lienRightsRequirements/$state'
      preLoaderRoute: typeof ALienRightsRequirementsStateRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/payApps/$payAppId': {
      id: '/_a/payApps/$payAppId'
      path: '/payApps/$payAppId'
      fullPath: '/payApps/$payAppId'
      preLoaderRoute: typeof APayAppsPayAppIdRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/peyote/debugger': {
      id: '/_a/peyote/debugger'
      path: '/peyote/debugger'
      fullPath: '/peyote/debugger'
      preLoaderRoute: typeof APeyoteDebuggerRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/projects/$projectId': {
      id: '/_a/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AProjectsProjectIdRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templateVariables/': {
      id: '/_a/templateVariables/'
      path: '/templateVariables'
      fullPath: '/templateVariables/'
      preLoaderRoute: typeof ATemplateVariablesIndexRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templateVariables/lookup': {
      id: '/_a/templateVariables/lookup'
      path: '/templateVariables/lookup'
      fullPath: '/templateVariables/lookup'
      preLoaderRoute: typeof ATemplateVariablesLookupRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templates/': {
      id: '/_a/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof ATemplatesIndexRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templates/create': {
      id: '/_a/templates/create'
      path: '/templates/create'
      fullPath: '/templates/create'
      preLoaderRoute: typeof ATemplatesCreateRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templates/match': {
      id: '/_a/templates/match'
      path: '/templates/match'
      fullPath: '/templates/match'
      preLoaderRoute: typeof ATemplatesMatchRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/users/$userId': {
      id: '/_a/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AUsersUserIdRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/companies/$companyId/': {
      id: '/_a/companies/$companyId/'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId/'
      preLoaderRoute: typeof ACompaniesCompanyIdIndexRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/companies/$companyId/formSets': {
      id: '/_a/companies/$companyId/formSets'
      path: '/companies/$companyId/formSets'
      fullPath: '/companies/$companyId/formSets'
      preLoaderRoute: typeof ACompaniesCompanyIdFormSetsRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templates/$templateId/': {
      id: '/_a/templates/$templateId/'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId/'
      preLoaderRoute: typeof ATemplatesTemplateIdIndexRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templates/$templateId/edit': {
      id: '/_a/templates/$templateId/edit'
      path: '/templates/$templateId/edit'
      fullPath: '/templates/$templateId/edit'
      preLoaderRoute: typeof ATemplatesTemplateIdEditRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templates/$templateId/versions/create': {
      id: '/_a/templates/$templateId/versions/create'
      path: '/templates/$templateId/versions/create'
      fullPath: '/templates/$templateId/versions/create'
      preLoaderRoute: typeof ATemplatesTemplateIdVersionsCreateRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templates/$templateId/versions/$versionId/': {
      id: '/_a/templates/$templateId/versions/$versionId/'
      path: '/templates/$templateId/versions/$versionId'
      fullPath: '/templates/$templateId/versions/$versionId/'
      preLoaderRoute: typeof ATemplatesTemplateIdVersionsVersionIdIndexRouteImport
      parentRoute: typeof ARoute
    }
    '/_a/templates/$templateId/versions/$versionId/edit': {
      id: '/_a/templates/$templateId/versions/$versionId/edit'
      path: '/templates/$templateId/versions/$versionId/edit'
      fullPath: '/templates/$templateId/versions/$versionId/edit'
      preLoaderRoute: typeof ATemplatesTemplateIdVersionsVersionIdEditRouteImport
      parentRoute: typeof ARoute
    }
  }
}

interface ARouteChildren {
  ASplatRoute: typeof ASplatRoute
  AAgaveConnectorStatusRoute: typeof AAgaveConnectorStatusRoute
  AAgaveEndpointsRoute: typeof AAgaveEndpointsRoute
  ABillingHistoryRoute: typeof ABillingHistoryRoute
  ACachingRoute: typeof ACachingRoute
  AContractMismatchReportGroupsRoute: typeof AContractMismatchReportGroupsRoute
  ACustomerDashboardsRoute: typeof ACustomerDashboardsRoute
  ACustomerLocationsMapRoute: typeof ACustomerLocationsMapRoute
  ADemoToolsRoute: typeof ADemoToolsRoute
  AFeatureFlagsRoute: typeof AFeatureFlagsRoute
  AFormTurnaroundRoute: typeof AFormTurnaroundRoute
  AGcDedupeRoute: typeof AGcDedupeRoute
  AIntegrationRequestsRoute: typeof AIntegrationRequestsRoute
  AJobsRoute: typeof AJobsRoute
  AProcessingContractsRoute: typeof AProcessingContractsRoute
  AReportingRoute: typeof AReportingRoute
  ASitelordRoute: typeof ASitelordRoute
  AWriteSyncOperationsRoute: typeof AWriteSyncOperationsRoute
  AIndexRoute: typeof AIndexRoute
  ACampaignsCampaignIdRoute: typeof ACampaignsCampaignIdRoute
  ACampaignsCreateRoute: typeof ACampaignsCreateRoute
  ACompaniesCreateRoute: typeof ACompaniesCreateRoute
  AContractsContractIdRoute: typeof AContractsContractIdRoute
  ALegalDocumentsRequirementIdRoute: typeof ALegalDocumentsRequirementIdRoute
  ALienRightsRequirementsStateRoute: typeof ALienRightsRequirementsStateRoute
  APayAppsPayAppIdRoute: typeof APayAppsPayAppIdRoute
  APeyoteDebuggerRoute: typeof APeyoteDebuggerRoute
  AProjectsProjectIdRoute: typeof AProjectsProjectIdRoute
  ATemplateVariablesLookupRoute: typeof ATemplateVariablesLookupRoute
  ATemplatesCreateRoute: typeof ATemplatesCreateRoute
  ATemplatesMatchRoute: typeof ATemplatesMatchRoute
  AUsersUserIdRoute: typeof AUsersUserIdRoute
  ACampaignsIndexRoute: typeof ACampaignsIndexRoute
  ALienRightsRequirementsIndexRoute: typeof ALienRightsRequirementsIndexRoute
  ATemplateVariablesIndexRoute: typeof ATemplateVariablesIndexRoute
  ATemplatesIndexRoute: typeof ATemplatesIndexRoute
  ACompaniesCompanyIdFormSetsRoute: typeof ACompaniesCompanyIdFormSetsRoute
  ATemplatesTemplateIdEditRoute: typeof ATemplatesTemplateIdEditRoute
  ACompaniesCompanyIdIndexRoute: typeof ACompaniesCompanyIdIndexRoute
  ATemplatesTemplateIdIndexRoute: typeof ATemplatesTemplateIdIndexRoute
  ATemplatesTemplateIdVersionsCreateRoute: typeof ATemplatesTemplateIdVersionsCreateRoute
  ATemplatesTemplateIdVersionsVersionIdEditRoute: typeof ATemplatesTemplateIdVersionsVersionIdEditRoute
  ATemplatesTemplateIdVersionsVersionIdIndexRoute: typeof ATemplatesTemplateIdVersionsVersionIdIndexRoute
}

const ARouteChildren: ARouteChildren = {
  ASplatRoute: ASplatRoute,
  AAgaveConnectorStatusRoute: AAgaveConnectorStatusRoute,
  AAgaveEndpointsRoute: AAgaveEndpointsRoute,
  ABillingHistoryRoute: ABillingHistoryRoute,
  ACachingRoute: ACachingRoute,
  AContractMismatchReportGroupsRoute: AContractMismatchReportGroupsRoute,
  ACustomerDashboardsRoute: ACustomerDashboardsRoute,
  ACustomerLocationsMapRoute: ACustomerLocationsMapRoute,
  ADemoToolsRoute: ADemoToolsRoute,
  AFeatureFlagsRoute: AFeatureFlagsRoute,
  AFormTurnaroundRoute: AFormTurnaroundRoute,
  AGcDedupeRoute: AGcDedupeRoute,
  AIntegrationRequestsRoute: AIntegrationRequestsRoute,
  AJobsRoute: AJobsRoute,
  AProcessingContractsRoute: AProcessingContractsRoute,
  AReportingRoute: AReportingRoute,
  ASitelordRoute: ASitelordRoute,
  AWriteSyncOperationsRoute: AWriteSyncOperationsRoute,
  AIndexRoute: AIndexRoute,
  ACampaignsCampaignIdRoute: ACampaignsCampaignIdRoute,
  ACampaignsCreateRoute: ACampaignsCreateRoute,
  ACompaniesCreateRoute: ACompaniesCreateRoute,
  AContractsContractIdRoute: AContractsContractIdRoute,
  ALegalDocumentsRequirementIdRoute: ALegalDocumentsRequirementIdRoute,
  ALienRightsRequirementsStateRoute: ALienRightsRequirementsStateRoute,
  APayAppsPayAppIdRoute: APayAppsPayAppIdRoute,
  APeyoteDebuggerRoute: APeyoteDebuggerRoute,
  AProjectsProjectIdRoute: AProjectsProjectIdRoute,
  ATemplateVariablesLookupRoute: ATemplateVariablesLookupRoute,
  ATemplatesCreateRoute: ATemplatesCreateRoute,
  ATemplatesMatchRoute: ATemplatesMatchRoute,
  AUsersUserIdRoute: AUsersUserIdRoute,
  ACampaignsIndexRoute: ACampaignsIndexRoute,
  ALienRightsRequirementsIndexRoute: ALienRightsRequirementsIndexRoute,
  ATemplateVariablesIndexRoute: ATemplateVariablesIndexRoute,
  ATemplatesIndexRoute: ATemplatesIndexRoute,
  ACompaniesCompanyIdFormSetsRoute: ACompaniesCompanyIdFormSetsRoute,
  ATemplatesTemplateIdEditRoute: ATemplatesTemplateIdEditRoute,
  ACompaniesCompanyIdIndexRoute: ACompaniesCompanyIdIndexRoute,
  ATemplatesTemplateIdIndexRoute: ATemplatesTemplateIdIndexRoute,
  ATemplatesTemplateIdVersionsCreateRoute:
    ATemplatesTemplateIdVersionsCreateRoute,
  ATemplatesTemplateIdVersionsVersionIdEditRoute:
    ATemplatesTemplateIdVersionsVersionIdEditRoute,
  ATemplatesTemplateIdVersionsVersionIdIndexRoute:
    ATemplatesTemplateIdVersionsVersionIdIndexRoute,
}

const ARouteWithChildren = ARoute._addFileChildren(ARouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ARoute: ARouteWithChildren,
  SigninRoute: SigninRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
